/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityUploadImportResponse } from './MonitEntityUploadImportResponse';
import {
    MonitEntityUploadImportResponseFromJSON,
    MonitEntityUploadImportResponseFromJSONTyped,
    MonitEntityUploadImportResponseToJSON,
} from './MonitEntityUploadImportResponse';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityUploadImportResponse
 */
export interface MonitPaginatedEntityUploadImportResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityUploadImportResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityUploadImportResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityUploadImportResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityUploadImportResponse>}
     * @memberof MonitPaginatedEntityUploadImportResponse
     */
    results?: Array<MonitEntityUploadImportResponse>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityUploadImportResponse interface.
 */
export function instanceOfMonitPaginatedEntityUploadImportResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityUploadImportResponseFromJSON(json: any): MonitPaginatedEntityUploadImportResponse {
    return MonitPaginatedEntityUploadImportResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityUploadImportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityUploadImportResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityUploadImportResponseFromJSON)),
    };
}

export function MonitPaginatedEntityUploadImportResponseToJSON(value?: MonitPaginatedEntityUploadImportResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityUploadImportResponseToJSON)),
    };
}

